"use strict";
var ApiQuoteRequest = (function () {
    function ApiQuoteRequest() {
    }
    return ApiQuoteRequest;
}());
exports.ApiQuoteRequest = ApiQuoteRequest;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-quote-request.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-quote-request.model.js